// extracted by mini-css-extract-plugin
export default {"container":"Zk-z","blurb":"_k-z","links":"al-z"};